
import { Component, Input } from '@angular/core';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { IconName } from 'src/app/components/icon/icons/icon-map';

@Component({
    selector: 'app-link',
    templateUrl: './app-link.component.html',
    styleUrls: ['./app-link.component.scss'],
    imports: [IconComponent]
})
export class AppLinkComponent {
  @Input() id?: string;
  @Input() text: string = '';
  @Input() icon?: IconName;
}
